import repository from "../Repository";

export default {
  /**
   * 参照API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async list(screenId, payload) {
    return await repository.post(`chronology_info`, payload, {
      headers: {
        s: screenId
      }
    });
  },
  /**
   * 登録API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async create(screenId, payload) {
    return await repository.post(`chronology_ope`, payload, {
      headers: {
        s: screenId
      }
    });
  },
  /**
   * 更新API（登録APIと処理は同じ）
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async update(screenId, payload) {
    return await this.create(screenId, payload);
  },
  /**
   * 削除API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async delete(screenId, payload) {
    return await repository.patch(`chronology_ope`, payload, {
      headers: {
        s: screenId
      }
    });
  }
};
